import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Exact } from "@Helpers/types/exact";
import type { UserPermissionsData, PortalSettingInfoData } from "@ServerTypes/portal/portal.schema";

export type {
  ResourceTypePermission,
  UserPermissionsData,
  PortalSettingInfoData,
} from "@ServerTypes/portal/portal.schema";

const userPermissionsSlice = createSlice({
  name: "userPermissions",
  initialState: {} as UserPermissionsData,
  reducers: {
    setUserPermissions: (_state: UserPermissionsData, action: PayloadAction<UserPermissionsData>) => action.payload,
  },
});

const portalSettingInfoSlice = createSlice({
  name: "portalSettingInfo",
  initialState: {} as PortalSettingInfoData,
  reducers: {
    setPortalSettingInfo: (_state: PortalSettingInfoData, action: PayloadAction<PortalSettingInfoData>) =>
      action.payload,
  },
});

const { setUserPermissions: _setUserPermissionsRaw } = userPermissionsSlice.actions;
const { setPortalSettingInfo: _setPortalSettingInfoRaw } = portalSettingInfoSlice.actions;

/**
 * Object-payload action creators are wrapped with `Exact<>` so excess properties
 * are caught even when the payload is passed through a variable.
 */
export const setUserPermissions = <T extends Exact<UserPermissionsData, T>>(payload: T) =>
  _setUserPermissionsRaw(payload);
export const setPortalSettingInfo = <T extends Exact<PortalSettingInfoData, T>>(payload: T) =>
  _setPortalSettingInfoRaw(payload);

export const userPermissions = userPermissionsSlice.reducer;
export const portalSettingInfo = portalSettingInfoSlice.reducer;
